<div *ngIf="pages.length as totalPages" class="paginator">
  <a [style.visibility]="currentPage > 1 ? 'visible':'hidden'" (click)="toPrevious()" class="paginator__option">
    <span class="paginator__option--prev"></span>
  </a>


  <ng-container *ngIf="currentPage >= 5 && 5 !== totalPages" >
    <a (click)="toFirst()" class="paginator__option">
      {{ 1 }}
    </a>
    <span class="paginator__option--ellipsis-first">...</span>
  </ng-container>


  <a *ngFor="let page of pagesPaginate"
     [ngClass]="{'paginator__option': true, 'paginator__option--active': currentPage === page }"
     (click)="onClick(page)"> {{ page }}
  </a>


  <ng-container *ngIf="(currentPage + (5 - 1) <= totalPages || currentPage <= (5 - 1)) && 5 < totalPages">
    <span class="paginator__option--ellipsis-last">...</span>
    <a (click)="toLast()" class="paginator__option">
      {{ totalPages }}
    </a>
  </ng-container>


  <a [style.visibility]="currentPage < totalPages ? 'visible':'hidden'" (click)="toNext()" class="paginator__option">
    <span class="paginator__option--next"></span>
  </a>
  
  
  <div class="paginator__selector">
    <p class="paginator__selector__paragraph">Registros por página: </p>

    <ng-select [multiple]="false" (change)="changeTotalToShow($event)" [searchable]="false"
               [items]="[5, 10, 25, 50, 100]" placeholder="5"
               class="paginator__selector__select">
    </ng-select>
  </div>
</div>

